import { EFilterJsonQueryActionType, TSetJsonQuery } from './types';

export function setJsonQuery(jsonQuery: object): TSetJsonQuery {
  return {
    type: EFilterJsonQueryActionType.SetJsonQuery,
    payload: jsonQuery,
  };
}
